import React, { useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';
import { v4 as uuid } from 'uuid';

import CustomModal from '../../../../../../../shared/components/v3/Modals/CustomModal/CustomModal';
import {
  INFORMATIVE_MODAL_ITEMS_FR,
  INFORMATIVE_MODAL_ITEMS
} from '../../../../../../../shared/constants/manageCollaborators';
import { TRANSLATION_MANAGE_COLLABORATORS } from '../../../../../../../shared/translations/manageCollaborators';

import './InformativeModal.scss';

interface InformativeModalProps {
  isFR: boolean;
}

const InformativeModal = ({ isFR }: InformativeModalProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [items] = useState<string[][]>(isFR ? INFORMATIVE_MODAL_ITEMS_FR : INFORMATIVE_MODAL_ITEMS);
  const { t } = useTranslation();

  const handleClick = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <button onClick={handleClick} className="ubf-helper-button">
        {t(TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.helperButton)}
      </button>
      <CustomModal open={openModal} onClose={closeModal} customClass="ubf-custom-modal">
        <div className="ubf-informative-modal">
          <div className="informative-modal-title">
            {t(TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.title)}
          </div>
          <div className="informative-modal-description">
            {t(
              TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal
                .description
            )}
          </div>
          <div className="informative-modal-items">
            {items.map((itemsList) => (
              <div className="informative-modal-items-column" key={uuid()}>
                {itemsList.map((item) => (
                  <li key={item} style={{ listStylePosition: 'inside' }}>
                    {t(item).toUpperCase()}
                  </li>
                ))}
              </div>
            ))}
          </div>
          <div className="informative-card">
            <Trans
              i18nKey={
                TRANSLATION_MANAGE_COLLABORATORS.uploadCollaboratorsSection.subscriptionByFile.informativeModal.infoCard
              }
              components={{
                b: <b></b>,
                br: <br />
              }}
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default InformativeModal;
